import { querystring } from './../../../helpers';
import debounce from 'lodash/debounce';

const FilterSearch = {
	name: 'FilterCheckboxItem',
	props: {
		placeholder: {
			type: String,
			required: true
		},
		fieldName: {
			type: String,
			required: true,
		},
		param: {
			type: String,
			required: true,
		},
	},
	methods: {
		debounceInput: _.debounce(function (e) {
			if(this.term.length > 0) {
				querystring.add(this.param, this.term, true);
			} else {
				querystring.remove(this.param, this.term, true);
			}
			this.$store.dispatch('filter/updated');
		}, 500),
	},
	data: function() {
		return {
			term: '',
		};
	},
	mounted: function() {
		this.term = querystring.getSingleValue(this.param);
	},
	template: `
		<div class="filter-group__search">
			<input type="text" :name="fieldName" v-model="term" @input="debounceInput" class="filter-search" :placeholder="placeholder" />
			<i class="icon-gunnebo-search"></i>
		</div>
	`,
};

export default FilterSearch;



// WEBPACK FOOTER //
// ../shared/components/filter/filter-search/index.js